import dom from "../../dist/jsx-render/dom";
import { app } from "./App";

export class Picture {
    public static show(id: number, name: string) {
        // black background
        let picElement = <div className="picture-container" tabIndex="0">
            <div className="pic-top d-flex">
                <div className="pic-name mr-auto">
                    {name}
                </div>
                <a className="pic-download" href={app.resolveUrl("~/api/documents/get/" + id)}>
                    <i className="fa fa-download"></i>
                </a>
                <div className="pic-close">
                    <i className="fa fa-times"></i>
                </div>
            </div>
            <img className="pic-img" src={app.resolveUrl("~/api/documents/get/" + id)} />
        </div>;

        // close on ESC
        picElement.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.keyCode == 27) {
                app.destroyDomElements(picElement);
            }
        });

        let divClose = picElement.querySelector(".pic-close") as HTMLElement;
        divClose.addEventListener("click", () => {
            app.destroyDomElements(picElement);
        });

        document.body.appendChild(picElement);
        picElement.focus();
    }
}